export const runtimeConfig={
  mainBaseUrl:(import.meta.env.VITE_QIRA_MAIN_BASE_URL||'https://qira.com.my').replace(/\/$/,''),
  apiBase:'/api/qcml',
  appName:'QCML',
  adminLabel:'QCML Admin'
} as const
